// Реестр десктопных рабочих мест ролей (E19, ТЗ §4.12). Каждая линейная роль,
// работающая за компьютером, получает своё split-view рабочее место. Выбор места —
// lookup по роли (WORKSPACE_BY_ROLE), без if-else: добавить роль = одна запись здесь.
// Роутер и навигация строятся из этого списка (router/index.ts, navigation-menu.ts).
import type { Role } from '@/services/rbac'
import type { Component } from 'vue'

export interface WorkspaceDef {
  /** роль-владелец места (по primaryRole пользователя) */
  role: Role
  /** route name в router/index.ts */
  routeName: string
  /** путь роута (как URL в дизайне crm-roles-desktop.jsx) */
  path: string
  /** i18n-ключ заголовка места (ru.json + en.json) */
  titleKey: string
  /** lazy-load компонента места — попадает в свой чанк */
  component: () => Promise<Component>
}

// Единый список всех рабочих мест. Руководители (уровень 2–3) мест не получают —
// их дом остаётся «Отчёты» (HOME_ROUTE_BY_ROLE), здесь только линейные роли.
export const WORKSPACES: WorkspaceDef[] = [
  {
    role: 'reception_admin',
    routeName: 'workspace-reception',
    path: '/reception',
    titleKey: 'workspaces.reception.title',
    component: () => import('@/workspaces/ReceptionWorkspace.vue'),
  },
  {
    role: 'call_center_operator',
    routeName: 'workspace-cc',
    path: '/cc',
    titleKey: 'workspaces.cc.title',
    component: () => import('@/workspaces/CallCenterWorkspace.vue'),
  },
  {
    role: 'sales_manager',
    routeName: 'workspace-mop',
    path: '/mop',
    titleKey: 'workspaces.mop.title',
    component: () => import('@/workspaces/MopWorkspace.vue'),
  },
  {
    role: 'appraisal_manager',
    routeName: 'workspace-moo',
    path: '/moo',
    titleKey: 'workspaces.moo.title',
    component: () => import('@/workspaces/MooWorkspace.vue'),
  },
]

/** Рабочее место по роли — точка резолва role → место (без if-else по ролям). */
export const WORKSPACE_BY_ROLE: Partial<Record<Role, WorkspaceDef>> = Object.fromEntries(
  WORKSPACES.map((workspace) => [workspace.role, workspace]),
)

/** Рабочее место по имени роута — для guard'а (проверка доступа к workspace-роуту). */
export const WORKSPACE_BY_ROUTE: Partial<Record<string, WorkspaceDef>> = Object.fromEntries(
  WORKSPACES.map((workspace) => [workspace.routeName, workspace]),
)
